import { device } from 'utils/device';
export default {
	smallSwipeVelocity: 5,
	bigSwipeVelocity: 10,
	device: 'android',
	browser: 'chrome',

	config: {
		default: {
			no: {
				swipePower: 0,
				ease: 10
			},
			small: {
				swipePower: 3,
				ease: 23
			},
			big: {
				swipePower: 3,
				ease: 25
			}
		},
		android: {
			no: {
				swipePower: 0,
				ease: 10
			},
			small: {
				swipePower: 3,
				ease: 23
			},
			big: {
				swipePower: 3,
				ease: 25
			}
		}
	},

	getSwipeEffect(pointerVelocity): any {
		let swipeType = this.getSwipeType(pointerVelocity);
		let swipeConfig = this.getConfig(swipeType);

		return {
			effect: swipeConfig.swipePower * pointerVelocity,
			ease: swipeConfig.ease,
			type: swipeType
		};
	},

	getConfig(swipeType: string) {
		if (this.config[this.device] && this.config[this.device][swipeType]) {
			return this.config[this.device][swipeType];
		}

		return this.config.default[swipeType];
	},

	getSwipeType(pointerVelocity: number) {
		let innerHeight = device.innerHeight;
		innerHeight = 600;
		if (Math.abs(pointerVelocity) < innerHeight * 0.05) return 'no';
		if (Math.abs(pointerVelocity) < innerHeight * 0.4) return 'small';
		return 'big';

	}
};
